/** Shared order bar: the original landing page and the new Sam homepage. */
(() => {
  if (customElements.get('sam-sticky-bar')) return;
  class SamStickyBar extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.bar = this.querySelector('[data-sticky-bar]');
      this.mobile = matchMedia('(max-width: 768px)');
      if (!this.bar) return;
      this.refreshTargets();
      this.queueUpdate = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      window.addEventListener('scroll', this.queueUpdate, { passive: true, signal });
      window.addEventListener('resize', this.queueUpdate, { signal });
      window.addEventListener('pageshow', this.queueUpdate, { signal });
      this.mobile.addEventListener('change', this.queueUpdate, { signal });
      document.addEventListener('shopify:section:load', () => { this.refreshTargets(); this.update(); }, { signal });
      document.addEventListener('shopify:section:unload', this.queueUpdate, { signal });
      document.addEventListener('shopify:section:reorder', this.queueUpdate, { signal });
      this.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        // Move keyboard focus with the in-page navigation, without jumping twice.
        const heading = target.querySelector('.sam-product__title, h1, h2');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
          heading.addEventListener('blur', () => heading.removeAttribute('tabindex'), { once: true });
        }
      }, { signal });
      this.update();
    }
    refreshTargets() {
      this.showAfter = document.querySelector(this.getAttribute('show-after'));
      this.hideAt = this.getAttribute('hide-at') && document.querySelector(this.getAttribute('hide-at'));
      this.readingSections = this.hasAttribute('hide-during-story') ? [...document.querySelectorAll('.sam-timeline')] : [];
    }
    update() {
      const ready = this.showAfter?.isConnected && (!this.hasAttribute('hide-while-visible') || this.hideAt?.isConnected);
      const mobileAllowed = !this.hasAttribute('mobile-only') || this.mobile.matches;
      let visible = false;
      if (ready && mobileAllowed) {
        const past = this.showAfter.getBoundingClientRect().bottom <= (this.hasAttribute('show-after-exit') ? 0 : window.innerHeight * .5);
        const target = this.hideAt?.getBoundingClientRect();
        const atProduct = target && (this.hasAttribute('hide-while-visible')
          ? target.top < window.innerHeight && target.bottom > 0
          : target.top < window.innerHeight * .9);
        const readingStory = this.readingSections?.some(section => {
          const rect = section.getBoundingClientRect();
          return rect.top < window.innerHeight && rect.bottom > 0;
        });
        visible = past && !atProduct && !readingStory;
      }
      this.bar.classList.toggle('show', visible);
      this.bar.inert = !visible;
      this.bar.setAttribute('aria-hidden', String(!visible));
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
    }
  }
  customElements.define('sam-sticky-bar', SamStickyBar);
})();
